import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
// Consider replacing these images with ones relevant to OBGYN/Women's Health if available
import obgynBg1 from './OB-GYN.png'; // Kept original paths, rename/replace images as needed
import obgynBg2 from '../../assets/img/clinic//2.png'; // Kept original paths, rename/replace images as needed
import { useState, useEffect } from 'react';
import hitakrilogo from '../../assets/img/hitakrilogo.png';


const ObGynInfertility = () => { // Changed component name
     const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    // Use the imported images - update these if you have OBGYN-specific visuals
    const images = [obgynBg1, obgynBg2]; // Used renamed variables for clarity
     const backgroundImage = images[currentImageIndex];

    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/clinic-and-specialities">Our Specialized Medical Departments</a></li>
                                    {/* Updated Breadcrumb */}
                                    <li className="breadcrumb-item active" aria-current="page">Obstetrics, Gynecology & Infertility Treatment</li>
                                </ol>
                            </nav>
                            {/* Updated Title */}
                            <h2 className="breadcrumb-title">Obstetrics, Gynecology & Infertility Treatment</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Breadcrumb */}

            <div className="content">
              {/* Full-Width Background with Minimal Text - Kept urology-header class as requested */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                    <p>
                                       <br />
                                         {/* Updated Header Text */}
                                         <strong>OB-GYN & Infertility Department at Hitkari Hospital</strong>
                                          </p>

                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">

                             <div className="terms-content">
                                <div className="terms-text">
                                     {/* Updated Content: Introduction */}
                                     <h3>Obstetrics, Gynecology & Infertility Department at Hitkari Hospital</h3>
                                       <p>The Department of Obstetrics, Gynecology (OB-GYN), and Infertility Treatment at Hitkari Hospital is dedicated to providing comprehensive, compassionate, and cutting-edge care for women through all stages of life. From adolescent health to pregnancy, childbirth, menopause, and beyond, our team of experienced obstetricians, gynecologists, fertility specialists, and dedicated nursing staff offers personalized care. We combine advanced medical technology with a patient-centered approach to manage routine check-ups, complex gynecological conditions, pregnancy care, and challenges related to infertility.</p>
                                </div>
                                <div className="terms-text">
                                     {/* Updated Content: Obstetrics Services */}
                                    <h3>Services Offered by the OB-GYN & Infertility Department</h3>
                                    <h4>1. Comprehensive Obstetric Care</h4>
                                    <ul>
                                        <li>Prenatal Care: Routine check-ups, ultrasound monitoring, genetic screening, and nutritional counseling for a healthy pregnancy journey.</li>
                                        <li>High-Risk Pregnancy Management: Specialized care for pregnancies complicated by maternal conditions (like diabetes, hypertension) or fetal concerns.</li>
                                        <li>Labor and Delivery Services: State-of-the-art labor suites, experienced delivery teams, options for pain management (including epidurals), and Cesarean section capabilities.</li>
                                        <li>Postnatal Care: Support and care for mothers and newborns after delivery, including lactation consultation and postpartum wellness checks.</li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                       {/* Updated Content: Gynecology Services */}
                                       <h4>2. General Gynecological Services</h4>
                                        <ul>
                                            <li>Annual Well-Woman Exams: Comprehensive check-ups including pelvic exams, Pap smears, and breast examinations for preventative care.</li>
                                            <li>Contraception Counseling and Management: Offering a wide range of birth control options tailored to individual needs and preferences.</li>
                                            <li>Management of Gynecological Conditions: Diagnosis and treatment of common issues like Polycystic Ovary Syndrome (PCOS), uterine fibroids, endometriosis, pelvic pain, and menstrual disorders.</li>
                                            <li>Menopause Management: Guidance and treatment options, including hormone replacement therapy (HRT), to manage menopausal symptoms.</li>
                                        </ul>
                                </div>
                                 <div className="terms-text">
                                      {/* Updated Content: Infertility Services */}
                                      <h4>3. Infertility Evaluation and Treatment</h4>
                                      <ul>
                                            <li>Comprehensive Fertility Assessment: Thorough evaluation for both partners to identify potential causes of infertility, including hormonal assays, imaging, and semen analysis.</li>
                                             <li>Ovulation Induction: Medical treatments to stimulate egg development and release for women with ovulatory disorders.</li>
                                            <li>Intrauterine Insemination (IUI): Procedure involving placement of prepared sperm directly into the uterus around the time of ovulation.</li>
                                            <li>Collaboration for Advanced Treatments: Coordination and referral for advanced reproductive technologies like In Vitro Fertilization (IVF) if required.</li>
                                        </ul>
                                 </div>
                                   <div className="terms-text">
                                       {/* Updated Content: Gynecological Surgery */}
                                       <h4>4. Gynecological Surgery</h4>
                                        <ul>
                                            <li>Minimally Invasive Surgery: Laparoscopic and hysteroscopic procedures for diagnosis and treatment of conditions like fibroids, ovarian cysts, and endometriosis, offering faster recovery.</li>
                                            <li>Major Gynecological Surgeries: Procedures such as hysterectomy (removal of the uterus), myomectomy (fibroid removal), and pelvic organ prolapse repair.</li>
                                             <li>Diagnostic Procedures: Colposcopy for abnormal Pap smears, endometrial biopsies, and diagnostic hysteroscopy.</li>
                                        </ul>
                                </div>
                                 <div className="terms-text">
                                         {/* Updated Content: Diagnostics */}
                                         <h4>5. Advanced Diagnostics and Screening</h4>
                                       <ul>
                                          <li>Obstetric and Gynecologic Ultrasound: High-resolution imaging for fetal monitoring, assessing pelvic organs, and diagnosing conditions.</li>
                                           <li>Fetal Monitoring: Non-stress tests (NST) and biophysical profiles (BPP) to assess fetal well-being during pregnancy.</li>
                                           <li>Coordination of Mammography: Facilitating breast cancer screening through referrals and follow-up.</li>
                                       </ul>
                                 </div>
                                  <div className="terms-text">
                                      {/* Updated Content: Why Choose */}
                                    <h3>Why Choose the OB-GYN & Infertility Department at Hitkari Hospital?</h3>
                                      <ul>
                                           <li>Experienced Team: Compassionate and skilled obstetricians, gynecologists, fertility experts, and specialized nurses.</li>
                                           <li>Comprehensive Care Spectrum: Addressing women's health needs from adolescence through post-menopause, including maternity and fertility services.</li>
                                            <li>Advanced Technology: Utilizing modern diagnostic tools like high-definition ultrasound and minimally invasive surgical equipment.</li>
                                            <li>Patient-Focused Approach: Personalized care plans, emphasizing patient education, comfort, and informed decision-making.</li>
                                           <li>Integrated Services: Seamless collaboration with other departments (like pediatrics, surgery, radiology) for holistic care.</li>
                                           <li>Focus on Safety and Comfort: Prioritizing safe practices in labor, delivery, and surgical procedures within a supportive environment.</li>
                                      </ul>
                                </div>
                                 <div className="terms-text">
                                    {/* Updated Content: Conclusion */}
                                    <p>At Hitkari Hospital, our OB-GYN & Infertility Department is committed to empowering women through exceptional healthcare. We strive to provide sensitive, expert care tailored to each individual's unique needs, supporting their health, well-being, and family-building goals with dignity and respect.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer">
            {/* Footer Top */}
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                                </div>
                                <div className="footer-about-content">
                                    <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                    <div className="social-icon">
                                        <ul>
                                            <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title">For Patients</h2>
                                <ul>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                    <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                    <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                    <li><a href="/booking"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Patient Dashboard</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title"
                                >
                                    For Patients
                                </h2>
                                <ul>
                                    <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                    <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                    <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Doctor Dashboard</a></li>
                                    <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                    <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                            <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                                <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                                <span>PIN – 344022</span>
                                            </div>
                                        </a>
                                    </div>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="tel:02988223100" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                            <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                            02988-223100
                                        </a>
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="mailto:hitkarihospitalblt2015@gmail.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                            <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                            hitkarihospitalblt2015@gmail.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="copyright-text">
                                    <p className="mb-0">
                                        <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight:'132px' }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </>
    );
};

export default ObGynInfertility; // Make sure to export the correct component name